import React from 'react';

import Inject from '../Inject';

class Modal extends React.PureComponent {

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  render() {
    // the inject seems to royally mess up the forms if the inject is within the form, must be something with passing context, I should look into that
    const { active, children, onClose, className = 'modal-container' } = this.props;
    return active ? (
      <div className={className}>
        <div className="modal">
          <button type="button" className="close-button" onClick={()=>onClose && onClose()}><i className="fi-x"></i></button>
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/app/components/Modal/Modal.js